import React, { useState, useEffect } from 'react';
import { validateUser, getAllUsers } from '../utils/userDatabase';

interface AccessGateProps {
  children: React.ReactNode;
}

export const AccessGate: React.FC<AccessGateProps> = ({ children }) => {
  // TEMPORARY BYPASS FOR PUBLISHER DEPLOYMENT - Remove this section to re-enable authentication
  const BYPASS_AUTH = true;
  // END BYPASS SECTION

  // All hooks must be called before any conditional returns
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    // Check if already authenticated in this session
    const authStatus = sessionStorage.getItem('travellerShipBuilderAccess');
    if (authStatus === 'granted') {
      setIsAuthenticated(true);
    }
  }, []);

  // BYPASS: Return children immediately if bypass is enabled
  if (BYPASS_AUTH) {
    return <>{children}</>;
  }

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const trimmedUsername = username.trim();
    const trimmedPassword = password.trim();
    
    const user = validateUser(trimmedUsername, trimmedPassword);
    if (user) {
      sessionStorage.setItem('travellerShipBuilderAccess', 'granted');
      sessionStorage.setItem('travellerShipBuilderUser', user.username);
      sessionStorage.setItem('travellerShipBuilderUserRole', user.role);
      setIsAuthenticated(true);
      setError('');
    } else {
      setError('Invalid username or password. Please try again.');
      setPassword('');
    }
  };

  if (isAuthenticated) {
    return <>{children}</>;
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-600 to-purple-700 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-xl p-8 max-w-md w-full">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-gray-800 mb-2">
            🚀 Traveller Ship Builder
          </h1>
          <p className="text-gray-600">Access Required</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Enter username"
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              required
              autoFocus
            />
          </div>
          <div>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              required
            />
          </div>

          {error && (
            <div className="text-red-600 text-sm text-center">{error}</div>
          )}

          <button
            type="submit"
            className="w-full bg-blue-600 text-white py-3 rounded-lg hover:bg-blue-700 transition-colors font-medium"
          >
            Access Application
          </button>
        </form>

        <div className="mt-6 text-center text-sm text-gray-500">
          This application is currently in private beta.<br />
          Contact the administrator for access.<br />
          <br />
          <div className="text-xs text-gray-400">
            Available users: {getAllUsers().map(user => user.username).join(', ')}
          </div>
        </div>
      </div>
    </div>
  );
};
